import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/index.scss'
import ElementUi from 'element-ui'
import * as filters from './filters'
import echarts from 'echarts'
import store from '@/store'
import { mixin } from '@/mixin/index'
import locale from 'element-ui/lib/locale/lang/en'
import '@/assets/iconfont/iconfont.css'
import Mathjax from '@/components/mathJax/mathJax'
import VueDragResize from 'vue-drag-resize'
import 'vue-mini-player/lib/vue-mini-player.css'
import vueMiniPlayer from 'vue-mini-player'
import Contextmenu from "vue-contextmenujs"
import dividingLine from '@/components/dividingLine'
import htmlToPdf from '@/utils/htmlToPdf.js'
Vue.use(htmlToPdf)
Vue.use(vueMiniPlayer)
Vue.use(Contextmenu);
Vue.component('vue-dividing-line', dividingLine)
Vue.component('vue-mathjax', Mathjax)
Vue.component('vue-drag-resize', VueDragResize)

Vue.prototype.$echarts = echarts

Vue.use(ElementUi, { locale })
Vue.config.productionTip = false
Vue.mixin({
  ...mixin
})
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
